import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import PlayIcon from "../../../../images/icons/play.svg"
import { GalleryVideoItem } from "../../model/gallery-item"
import "./video-preview.sass"

const VideoPreview = ({ galleryVideo, className, ...props }) => {
  return (
    <div className={classNames("_fp-video-preview", className)} {...props}>
      <div className="_fp-video-preview__thumbnail">
        <img src={galleryVideo.thumbnailSrc} alt="" />
        <div className="_fp-video-preview__thumbnail__icon">
          <PlayIcon />
        </div>
      </div>
    </div>
  )
}

VideoPreview.propTypes = {
  galleryVideo: PropTypes.instanceOf(GalleryVideoItem).isRequired,
}

export default VideoPreview
